import { render } from "./CategoryCard.vue?vue&type=template&id=6ea166dc"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=6ea166dc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Cards/CategoryCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ea166dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ea166dc', __exports__)) {
    api.reload('6ea166dc', __exports__)
  }
  
  module.hot.accept("./CategoryCard.vue?vue&type=template&id=6ea166dc", () => {
    api.rerender('6ea166dc', render)
  })

}


export default __exports__